import React from 'react';
import { Select } from 'antd';
import { FormItemHeight } from '../constants';
var Option = Select.Option;
var SelectField = function (props) {
    var _a = props.label, label = _a === void 0 ? '箭头' : _a, value = props.value, onChange = props.onChange, _b = props.options, options = _b === void 0 ? [] : _b, width = props.width;
    return (React.createElement("div", { className: "group" },
        React.createElement("label", null, label),
        React.createElement(Select, { size: "small", value: value, style: {
                width: width,
                height: FormItemHeight,
            }, getPopupContainer: function (trigger) { return trigger.parentNode; }, optionFilterProp: "children", onChange: function (value) {
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            }, filterOption: function (input, option) { return (option === null || option === void 0 ? void 0 : option.children.toLowerCase().indexOf(input.toLowerCase())) >= 0; } }, options.map(function (option) { return (React.createElement(Option, { key: option.label, value: option.value }, option.label)); }))));
};
export default SelectField;
